import React from 'react';
import Header from 'components/Header';
import { Outlet, useLocation } from 'react-router-dom';
import './styles/theme.scss'
import SidePane from 'components/SidePane';
import SidepaneContent from 'Modules/Sidepane';
import { ReactComponent as DfhLogo } from 'assets/dfh_logo.svg';
import styles from './App.module.scss'
import { ModalsProvider } from '@mantine/modals';
import DrawerModal from 'components/DrawerModal';
import LeadDrawer from 'components/LeadDrawer';

import PractitionerListDrawer from 'components/PractitionerListDrawer';
import RoutesDrawer from 'components/RoutesDrawer';
import OppsAndRisksDrawer from 'components/OppsAndRisksDrawer';
import { Box } from '@mantine/core';
import useOnlineStatus from 'hooks/useOnlineStatus';

const App: React.FC = () => {

  const [isSidepaneOpen, setIsSidepaneOpen] = React.useState<boolean>(false)
  const isOnline = useOnlineStatus();
  const location = useLocation();
  const toggleSidePane = () => {
    setIsSidepaneOpen(!isSidepaneOpen)
  }

  /*React.useEffect(() => {
    if (store.user?.userName) {
      console.time("amplitude-init");
      init(AMPLITUDE_KEY, store.user.userName);
      console.timeEnd("amplitude-init");
      console.log("Logging user name from App.tsx:", store.user?.userName);
      setUserId(store.user.userName);
    }
  }, [store.user?.userName]);*/

  return (
    <SidePane
      togglePane={toggleSidePane}
      isOpen={isSidepaneOpen}
      header='Sales Assistant AI'
      sidepaneContent={<SidepaneContent togglePane={toggleSidePane}/>}>
      {!isOnline ? (
        <Box h={10} ta="center" bg="red" c="white" w="100%"
          pos="absolute" top={0} left={0} fz={10} fw="bold"
          style={{zIndex: 999999999}}>
          OFFLINE
        </Box>
      ): null}
      <ModalsProvider modals={{
          "drawerModal": DrawerModal,
          "leadDrawer": LeadDrawer,
          "practitionerListDrawer": PractitionerListDrawer,
          "routesDrawer": RoutesDrawer,
          "oppsAndRisksDrawer": OppsAndRisksDrawer
          }}>
          <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }}>
            {!location.pathname.includes("navigation-mode") && !location.pathname.includes("mapView") ? (
              <Header toggleSidePane={toggleSidePane} isSidepaneOpen={isSidepaneOpen} />
            ): null}
            <Outlet />
          </div>
          {!location.pathname.includes("mapView") && !location.pathname.includes("navigation-mode") ? (
            <div className={styles.dfhLogoContainer}>
              <DfhLogo className={styles.dfhLogo} />
            </div>
          ) : null}
      </ModalsProvider>
    </SidePane>
  );
}


export default App;